"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyDisplayRequest = void 0;
var ApplyDisplayRequest = /** @class */ (function () {
    function ApplyDisplayRequest() {
    }
    return ApplyDisplayRequest;
}());
exports.ApplyDisplayRequest = ApplyDisplayRequest;
;
//# sourceMappingURL=applyDisplay.request.js.map